import { nanoid } from "nanoid"
import { useCallback, useState } from "react"
import {
  ToastContext,
  type ToastInfo,
  type ToastOptions,
} from "~/context/ToastContext"
import type { ToastType } from "~/ur-react-components"
import ToastContainer from "./ToastContainer"

export type ToastProviderProps = {}

const ToastProvider: React.CFC<ToastProviderProps> = ({ children }) => {
  const [toasts, setToasts] = useState<ToastInfo[]>([])

  const addToast = useCallback(
    async (type: ToastType, message: string, options?: ToastOptions) => {
      const life = options?.life ?? 7500
      const id = nanoid()
      const toast = { id, type, message, options }
      setToasts((toasts) => [...toasts, toast])

      await new Promise((resolve) => setTimeout(resolve, life))

      setToasts((toasts) => toasts.filter((t) => t !== toast))
    },
    [],
  )

  return (
    <ToastContext.Provider value={addToast}>
      <ToastContainer toasts={toasts} />
      {children}
    </ToastContext.Provider>
  )
}

export default ToastProvider
